// Shared prune for the Dexie `workspaces` table. Every snapshot writer (shell bootstrap,
// `/workspaces` refresh) has to drop rows the server no longer returns, optionally holding
// back the workspace the page is currently rendering so shared-channel loads don't blank it.
export async function pruneStaleWorkspaces(database, workspaces, { preserveWorkspaceId = null } = {}) {
  const keepIds = new Set(workspaces.map((workspace) => workspace.id));
  if (preserveWorkspaceId) keepIds.add(preserveWorkspaceId);

  const existingIds = await database.workspaces.toCollection().primaryKeys();
  const staleIds = existingIds.filter((id) => !keepIds.has(id));
  if (staleIds.length > 0) await database.workspaces.bulkDelete(staleIds);

  return staleIds;
}
